import { useState } from "react";
import { BookOpen, FileText, HelpCircle, Lightbulb } from "lucide-react";
import TopQuestionsPanel from "./TopQuestionsPanel";
import KnowledgeGapsPanel from "./KnowledgeGapsPanel";
import FaqEntriesPanel from "./FaqEntriesPanel";
import ChapterEntriesPanel from "./ChapterEntriesPanel";

export default function HelpInsightsTabs({ refreshKey, gapsOpen, onChanged }) {
  const [tab, setTab] = useState("top");
  const tabs = [
    { id: "top", label: "Meest gestelde vragen", Icon: HelpCircle },
    { id: "gaps", label: "Kennisgaten", Icon: Lightbulb, badge: gapsOpen },
    { id: "faq", label: "FAQ-regels", Icon: BookOpen },
    { id: "chapters", label: "Paragrafen", Icon: FileText },
  ];
  return (
    <div className="border-2 border-foreground bg-background" data-testid="help-insights">
      <div className="flex flex-wrap border-b-2 border-foreground" role="tablist">
        {tabs.map(({ id, label, Icon, badge }) => (
          <button key={id} role="tab" aria-selected={tab === id} onClick={() => setTab(id)} data-testid={`help-tab-${id}`}
            className={`px-4 py-2.5 font-display font-black uppercase tracking-tight text-sm inline-flex items-center gap-2 border-r-2 border-foreground transition-colors ${tab === id ? "bg-foreground text-background" : "hover:bg-muted"}`}>
            <Icon className="w-4 h-4" /> {label}
            {badge > 0 && <span className={`font-mono-num text-[11px] px-1.5 py-0.5 ${tab === id ? "bg-background text-foreground" : "bg-destructive text-white"}`} data-testid="help-tab-gaps-badge">{badge}</span>}
          </button>
        ))}
      </div>
      {tab === "top" && <TopQuestionsPanel refreshKey={refreshKey} onChanged={onChanged} />}
      {tab === "gaps" && <KnowledgeGapsPanel refreshKey={refreshKey} onChanged={onChanged} />}
      {tab === "faq" && <FaqEntriesPanel refreshKey={refreshKey} onChanged={onChanged} />}
      {tab === "chapters" && <ChapterEntriesPanel refreshKey={refreshKey} onChanged={onChanged} />}
    </div>
  );
}
